export var getFilterIndex = function (filters, regexp) {
    var index = -1;
    for (var i = 0; i < filters.length; i++) {
        var filterMatch = filters[i].match(regexp) || [];
        if (filterMatch.length > 0) {
            index = i;
            break;
        }
        regexp.lastIndex = 0;
    }
    regexp.lastIndex = 0;
    return index;
};
